// make our action generators utility functions for ease of use. Practically there is no difference between
// this method and just calling dispatch({ type: '', payload: {} }) with the appropriate values
const onLevelButtonOverAction = payload => {
    return { type: 'LEVEL_BUTTON_OVER', payload };
};

export default onLevelButtonOverAction;


// WEBPACK FOOTER //
// ./src/actions/onLevelButtonOverAction.js